module.exports = __webpack_public_path__ + "img/xiaozi_gongyinglian.9e454770.svg";